import { IFooterLinkItem } from "../Navigation/Footer/FooterWidget/FooterLinks/FooterLinks";

export const sushiShopLinks: IFooterLinkItem[] = [
  {
    label: "Carte 2022",
  },
  {
    label: "Nos Shops",
  },
  {
    label: "Actualités",
  },
  {
    label: "Fidélité Come In",
  },
  {
    label: "Service Client",
  },
  {
    label: "Parrainage",
  },
  {
    label: "Allergènes",
  },
  {
    label: "Glossaire des ingrédients",
  },
];

export const aboutLinks: IFooterLinkItem[] = [
  {
    label: "Devenez franchisé !",
  },
  {
    label: "Nos corners en hypermarchés",
  },
  {
    label: "Recrutement",
  },
  {
    label: "Presse",
  },
];

export const followUsLinks: IFooterLinkItem[] = [
  {
    label: "Facebook",
    icon: "logo_facebook",
  },
  {
    label: "Twitter",
    icon: "logo_twitter_x",
  },
  {
    label: "Instagram",
    icon: "logo_instagram",
  },
  {
    label: "Linkedin",
    icon: "logo_linkedin",
  },
];
export const footerParagraphs = [
  {
    label: "Sushi Shop dans votre ville",
    description:
      "Paris Marseille Lyon Lille Nice Bordeaux Nantes Grenoble Rennes Strasbourg",
  },
  {
    label: "Sushi Shop dans votre région",
    description:
      "Île-De-France Auvergne-Rhône-Alpes Provence-Alpes-Côte d'Azur Pays de la Loire Nouvelle-Aquitaine",
  },
  {
    label: "Sushi Shop dans le monde",
    description:
      "United Kingdom Belgique Luxembourg Suisse Italia España United Arab Emirates Saudi Arabia",
  },
];
export const footerLegalMentions = [
  {
    label: "CGV",
  },
  {
    label: "Mentions Légales",
  },
  {
    label: "CGU Come In",
  },
  {
    label: "Politique de cookies",
  },
];
